import Clientes from "../views/modulos/crm/cliente/List.vue";
import ClientesForm from "../views/modulos/crm/cliente/Form.vue";
import Cotizacion from "../views/modulos/crm/cotizacion/List.vue";
import FormCotizacion from "../views/modulos/crm/cotizacion/Form.vue";
import Asignacion from "../views/modulos/crm/asignacionPersonal/List.vue";
import Condiciones from "../views/catalogos/condicionContrato/List.vue";
import Agenda from "../views/modulos/crm/agenda/List.vue";
import Calendario from "../views/modulos/crm/calendario/List.vue";
import Encuesta from '../views/modulos/crm/encuesta/List.vue';
import OpcionEncuesta from '../views/modulos/crm/encuesta/opciones/List.vue';
import OpcionEncuestaForm from '../views/modulos/crm/encuesta/opciones/Form.vue';
import Pregunta from '../views/modulos/crm/encuesta/pregunta/List.vue';
import Respuesta from '../views/modulos/crm/encuesta/respuesta/List.vue';
import ConfiguracionSeguimiento from '../views/modulos/crm/configseguimiento/List.vue';
import EnviarEncuesta from '../views/modulos/crm/encuesta/EnviarEncuesta.vue';
import EncuestaResueltaLista from '../views/modulos/crm/encuestaResuelta/List.vue';
import RendimientoEncuesta from '../views/modulos/crm/rendimientoEncuesta/Principal.vue';
import RendimientoCotizacion from '../views/modulos/crm/rendimientoCotizacion/Rendimiento.vue';
import RendimientoEvento from '../views/modulos/crm/rendimientoEvento/RendimientoEvento.vue';
import Bitacora from '../views/modulos/crm/bitacora/List.vue';
import CartaDeBienvenida from '../views/modulos/crm/cartaDeBienvenida/List.vue';
import PlanDeVentas from '../views/modulos/crm/planDeVentas/List.vue';
import SeguimientoAcciones from '../views/modulos/crm/seguimientoacciones/SeguimientoAcciones.vue';

const VarRutasCrm = [
    {
        path: '/Prospectos',
        name: 'prospectos',
        component: Clientes,
        props: true
    },
    {
        path: '/ClientesForm',
        name: 'clientesform',
        component: ClientesForm,
        props: true
    },
    {
        path: '/Cotizacion',
        name: 'cotizacion',
        component: Cotizacion,
        props: true
    },
    {
        path: '/CotizacionForm',
        name: 'formCotizacion',
        component: FormCotizacion,
        props: true
    },
    {
        path: '/AsignarPersonal',
        name: 'asignacionPersonal',
        component: Asignacion,
        props: true
    },
    {
        path: '/SeguimientoAcciones',
        name: 'seguimientoacciones',
        component: SeguimientoAcciones,
        props: true
    },
    {
        path: '/Encuesta',
        name: 'encuesta',
        component: Encuesta,
        props: true
    },
    {
        path: '/OpcionEncuesta',
        name: 'opcionencuesta',
        component: OpcionEncuesta,
        props: true
    },
    {
        path: '/OpcionEncuestaForm',
        name: 'opcionencuestaform',
        component: OpcionEncuestaForm,
        props: true
    },
    {
        path: '/Pregunta',
        name: 'preguntas',
        component: Pregunta,
        props: true
    },
    {
        path: '/Respuesta',
        name: 'respuestas',
        component: Respuesta,
        props: true
    },
    {
        path: '/ConfiguracionSeguimiento',
        name: 'configSeguimiento',
        component: ConfiguracionSeguimiento,
        props: true
    },
    {
        path: '/CondicionesDelContrato',
        name: 'condicioncontrato',
        component: Condiciones,
        props: true
    },
    {
        path: '/Agenda',
        name: 'agenda',
        component: Agenda,
        props: true
    },
    {
        path: '/Calendario',
        name: 'calendario',
        component: Calendario,
        props: true
    },
    {
        path: '/EnviarEncuesta',
        name: 'enviarEncuesta',
        component: EnviarEncuesta,
        props: true
    },
    {
        path: '/EncuestaRespuestas',
        name: 'encuestaRespuestas',
        component: EncuestaResueltaLista,
        props: true
    },
    {
        path: '/RendimientoEncuesta',
        name: 'rendimientoEncuesta',
        component: RendimientoEncuesta,
        props: true
    },
    {
        path: '/RendimientoCotizacion',
        name: 'rendimientoCotizacion',
        component: RendimientoCotizacion,
        props: true
    },
    {
        path: '/EventoSeguimeinto',
        name: 'rendimientoEvento',
        component: RendimientoEvento,
        props: true
    },
    {
        path: '/Bitacora',
        name: 'bitacora',
        component: Bitacora,
        props:true
    },
    {
        path: '/CartaDeBienvenida',
        name: 'cartaDeBienvenida',
        component: CartaDeBienvenida,
        props: true
    },
    {
        path: '/PlanDeVentas',
        name: 'planDeVentas',
        component: PlanDeVentas,
        props: true
    },
];

export default {
    VarRutasCrm,
}